<template>
  <div class="aut">
    <!-- 拍卖车辆 -->
    <div class="aut-auto wrap">
      <h1>拍卖车辆</h1>
      <!-- 四个图片列表 -->
      <div class="aut-auto-images" v-if="list.length > 0">
        <div
          v-for="item in list"
          :key="item.carId"
          class="aut-item"
          @click="handleGoCardDetails(item)"
        >
          <div class="aut-auto-images-item">
            <div class="imageUrl">
              <div class="imageUrl-h4">
                <p>
                  {{ displayAccidentTypes(item.accidentType?.split(",")[0]) }}
                </p>
              </div>
              <el-image
                class="imageUrl-img"
                :src="item.img?.length > 0 ? item.img : defaultImg"
                alt=""
                fit="cover"
              />
            </div>

            <!-- 每一个item项 -->
            <div class="item-box">
              <span class="label">
                <p class="label-header" :title="getTooltipContent(item)">
                  {{ item.initialTime.split(" ")[0].split("-")[0] }}
                  {{ item.brand }}{{ item.carType }}
                </p>

                <span>￥{{ item.startingPrice }}</span>
              </span>
              <p class="label2">
                车牌：{{ item.carNumber }} &nbsp;&nbsp;暂存地：{{
                  item.institutionAddress
                }}
              </p>
              <p class="label2">
                初登日期:{{ item.initialTime.split(" ")[0] }}
              </p>
            </div>
          </div>
        </div>
      </div>
      <div v-else><el-empty :image-size="200"></el-empty></div>
      <div class="footer-btn-box">
        <el-button class="footer-btn" :loading="btnLoading" @click="handleMore">
          立即查看
        </el-button>
      </div>
    </div>
  </div>
</template>

<script>
import { defaultImg } from "@/data";
import { findSysConfigAuctionCar } from "@/api/auctionVehicles";
import { displayAccidentTypes } from "@/data";
export default {
  data() {
    return {
      btnLoading: false,
      //图片前缀
      // 拍卖会列表
      list: [],
      pageInfo: {
        currentPage: 1,
        pageSize: 4,
        total: 0,
      },
      defaultImg,
      displayAccidentTypes,
    };
  },
  mounted() {
    // this.queryType = this.$route.query.type;
    this.handleFindSysConfigAuctionCar();
  },
  methods: {
    getTooltipContent(item) {
      return `${item.initialTime?.split("-")[0]}${item.brand ?? ""} ${
        item.carType ?? ""
      }`;
    },
    async handleFindSysConfigAuctionCar() {
      this.btnLoading = true;
      let res = await findSysConfigAuctionCar({
        // currentPage: this.pageInfo.currentPage,
        // pageSize: this.pageInfo.pageSize,
      });
      if (res.success) {
        this.list = res.pageInfo.list
          .map((item) => {
            // 检查 item.exterior 是否为字符串，然后再调用 split
            const image =
              typeof item.exterior[0] === "string"
                ? item.exterior[0].split(",")[0]
                : null;

            return {
              ...item,
              img: image || null, // 如果 image 为 null，则 img 也为 null，或者可以设置一个默认图片链接
            };
          })
          .slice(0, this.pageInfo.pageSize);

        this.pageInfo.total = res.pageInfo.list.length - 1;
      }
      this.btnLoading = false;
    },

    //   查看更多
    handleMore() {
      if (this.btnLoading) {
        return; // 如果按钮处于加载状态，则直接返回，不执行后续操作
      }
      if (
        this.pageInfo.currentPage * this.pageInfo.pageSize >=
        this.pageInfo.total
      ) {
        this.$message.warning("没有更多了");
        return;
      }

      this.pageInfo.pageSize += 4;
      this.handleFindSysConfigAuctionCar();
    },
    // 查看详情
    handleGoCardDetails(i) {
      this.$router.push({
        path: "/VehicleDetails",
        query: {
          carId: i.carId,
        },
      });
    },
  },
};
</script>

<style lang="less" scoped>
.aut {
  width: 100%;

  .aut-auto {
    padding: 20px 0;

    h1 {
      text-align: center;
      padding: 20px 20px 40px 20px;
      font-size: 24px;
    }

    .aut-auto-images {
      width: 1290px;
      display: grid;
      grid-template-columns: repeat(4, 1fr);
      gap: 10px;
      margin: 0 auto;
      flex-wrap: wrap;
      justify-content: left;
      .aut-item {
        margin-bottom: 20px;
      }
      .imageUrl {
        // width: 290px;
        // height: 200px;
        position: relative;
        border-radius: 10px;

        .imageUrl-h4 {
          z-index: 1;
          position: absolute;
          /*绝对定位*/
          width: 70px;
          height: 34px;
          line-height: 34px;
          background-color: #f96a26;
          border-top-left-radius: 10px;
          border-bottom-right-radius: 10px;

          p {
            text-align: center;
            font-size: 18px;
            color: white;
          }
        }

        .imageUrl-img {
          width: 100%;
          height: 200px;
          border-top-left-radius: 10px;
          border-top-right-radius: 10px;
          box-sizing: border-box;
        }
      }

      .aut-auto-images-item {
        width: 320px;
        text-align: left;
        line-height: 30px;
        background-color: #fff;
        border-radius: 10px;
        border: 1px solid #e4e2e2;
        cursor: pointer;
        box-sizing: border-box;

        .item-box {
          padding: 20px 18px;
        }

        .label {
          color: #070707;
          font-size: 20px;
          padding: 3px 0;
          width: 100%;
          display: flex;
          justify-content: space-between;
          .label-header {
            width: 100%;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }

          span {
            margin-left: 70px;
            color: #f96a26;
          }
        }

        .label2 {
          width: 260px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          color: #999999;
          padding: 3px 0;
        }
      }
    }
    .footer-btn-box {
      display: flex;
      justify-content: center;
      margin: 28px 0;
    }
    .footer-btn {
      border: 1px solid #f96a26;
      border-radius: 50px;
      cursor: pointer;
      padding: 10px 20px;
      color: #f96a26;
      opacity: 0.7;
      font-size: 16px;

      &:hover,
      &:focus {
        background: none;
      }
    }
  }
}
</style>